<div class="component-main-container">
  <app-page-header parentTitle="Cadastro"></app-page-header>
  <div class="row">
    <div class="col-lg-4 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>
      </div>
    </div>
  </div>
</div>
